export enum OrientationSection {
    Overview = 'Overview',
    Compliance = 'Compliance',
    Payroll = 'Payroll',
    Housing = 'Housing & Transportation',
    Benefits = 'Benefits',
    AdditionalBenefits = 'Additional Benefits',
    ProfessionalPerks = 'Professional Perks',
    Facility = 'Facility Orientation',
    FinalNotes = 'Final Notes'
}

export const SectionTypeIdMap = new Map<OrientationSection, number>([
    [OrientationSection.Overview, 1],
    [OrientationSection.Compliance, 2],
    [OrientationSection.Payroll, 5],
    [OrientationSection.Housing, 6],
    [OrientationSection.Benefits, 3],
    [OrientationSection.AdditionalBenefits, 4],
    [OrientationSection.ProfessionalPerks, 7],
    [OrientationSection.Facility, 9],
    [OrientationSection.FinalNotes, 11]
]);
